<template>
  <div v-if="currentMission">
    <div class="row">
      <div class="col-md-6 col-lg-6">
        <BreadCrumd
          :title="'Missions'"
          :description="'Modification d\'une mission'"
        />
      </div>
      <div class="col-md-6 col-lg-6 mt-lg-4" v-if="currentMission.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence : {{ currentMission.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      :style="`color: ${currentMission.statut_obj.couleur}`"
                      :class="icons.ICON_STATUT"
                    ></i>
                    {{ currentMission.statut_obj.nom }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4 mt-2"
          @click.prevent="$router.push({ name: 'crm_mission' }).catch(() => {})"
        >
          Liste des missions
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4 mt-2"
          @click.prevent="
            $router.push({ name: 'crm_mission-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle mission
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mt-2"
          @click.prevent="
            $router
              .push({
                name: 'crm_mission-show',
                params: { id: currentMission.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>

      <div class="col-md-12 mt-md-2 mt-lg-0 col-lg-6">
        <b-button
          variant="warning"
          class="btn-icon mr-4 mt-2"
          v-if="currentMission.statut > 0"
          @click.prevent="reinitialiser()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_RESET"></i>
          </span>
          Mettre en attente
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mr-4 mt-2"
          v-if="currentMission.statut === 0"
          @click.prevent="commencer()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_START"></i>
          </span>
          Commencer
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mr-4 mt-2"
          v-if="currentMission.statut === 2"
          @click.prevent="reprendre()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_START"></i>
          </span>
          Continuer
        </b-button>

        <b-button
          variant="warning"
          class="btn-icon mr-4 mt-2"
          v-if="currentMission.statut === 1"
          @click.prevent="mettreEnPause()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_PAUSE"></i>
          </span>
          Mettre en pause
        </b-button>

        <b-button
          variant="danger"
          class="btn-icon mr-4 mt-2"
          v-if="currentMission.statut === 1"
          @click.prevent="cloturer()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_STOP"></i>
          </span>
          Cloturer
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mt-2"
          v-if="currentMission.statut === 1"
          @click.prevent="achever()"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_FINISH"></i>
          </span>
          Achever
        </b-button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'crm_mission-edit',
                params: { id: currentMission.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-edit text-custom-primary font-size-17"></i>
              Mission</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_mission_edit-document',
                params: {
                  documentUuid: currentMission.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-paperclip text-custom-primary font-size-17"></i>
              Documents</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_mission-edit-tache',
                params: {
                  id: currentMission.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Tâches</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import URL from '@/http/crm/mission/mission';
import icons from '@/icons/crm/mission';
export default {
  data() {
    return {
      title: 'Gestion des missions - Aperçu',
      icons,
    };
  },
  computed: {
    ...mapGetters('mission', ['currentMission']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('mission', ['getMission']),
    init() {
      this.getMission(this.$route.params.id).then(() => {
        if (this.currentMission.statut !== 0) {
          this.$router.push({
            name: 'crm_mission-show',
            params: { id: this.currentMission.id },
          });
        }
      });
    },
    commencer() {
      this.showConfirmValidation()
        .then((result) => {
          if (result.value) {
            this.sendAction(URL.MISSION_START);
          }
        })
        .catch();
    },

    mettreEnPause() {
      this.showConfirmValidation()
        .then((result) => {
          if (result.value) {
            this.sendAction(URL.MISSION_PAUSE);
          }
        })
        .catch();
    },
    reprendre() {
      this.showConfirmValidation()
        .then((result) => {
          if (result.value) {
            this.sendAction(URL.MISSION_CONTINUE);
          }
        })
        .catch();
    },
    cloturer() {
      this.showConfirmValidation()
        .then((result) => {
          if (result.value) {
            this.sendAction(URL.MISSION_CLOSE);
          }
        })
        .catch();
    },
    achever() {
      this.showConfirmValidation()
        .then((result) => {
          if (result.value) {
            this.sendAction(URL.MISSION_FINISH);
          }
        })
        .catch();
    },
    reinitialiser() {
      this.showConfirmValidation()
        .then((result) => {
          if (result.value) {
            this.sendAction(URL.MISSION_RESET);
          }
        })
        .catch();
    },

    sendAction(action) {
      window.axios
        .post(URL.MISSION + '/' + this.currentMission.id + action)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.init();
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>
